
import React, { useEffect, useState, useRef, useCallback } from "react";
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FaInfoCircle } from "react-icons/fa";
import './Ordercart.css';
import axios from 'axios';
import { useParams } from "react-router-dom";
import { useLocation as useRouteLocation } from "react-router-dom";
import Sheduleorder from "./Sheduleorder";
import Paymentdata from "./Paymentdata";
import dayjs from "dayjs";

const Ordercart = ({ filteredDataProp = [], data }) => {
    const navigate = useNavigate();
    const routeLocation = useRouteLocation();
    const { id } = useParams();

    const [cartItems, setCartItems] = useState([]);
    const [quantities, setQuantities] = useState({});
    const [displayData, setDisplayData] = useState([]);
    const [allCategories, setAllCategories] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [activeCategory, setActiveCategory] = useState("Allcarts");

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
    const [isThirdModalOpen, setIsThirdModalOpen] = useState(false);

    const [selectedOrderType, setSelectedOrderType] = useState(null);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedTime, setSelectedTime] = useState('');
    const [savedDetails, setSavedDetails] = useState(null);

    const [subTotal, setSubTotal] = useState(0);
    const [total, setTotal] = useState(0);
    const [gstTotal, setGstTotal] = useState(0);
    const [platformCharges, setPlatformCharges] = useState(0);
    const [serviceCharges, setServiceCharges] = useState(0);
    const [packingCharges, setPackingCharges] = useState(0);
    const [deliveryCharges, setDeliveryCharges] = useState(0);
    const [discountAmount, setDiscountAmount] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);

    const [serviceApplied, setServiceApplied] = useState(true);

    const [availableBalance, setAvailableBalance] = useState(0);
    const [availableCompany, setAvailableCompany] = useState(0);
    const [availableSelf, setAvailableSelf] = useState(0);
    const [availableCashback, setAvailableCashback] = useState(0);

    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
    const [selectedwalletTypes, setSelectedwalletTypes] = useState("");
    const [showWalletOptions, setShowWalletOptions] = useState(false);

    const [isWalletChecked, setIsWalletChecked] = useState(false);
    const [isCashChecked, setIsCashChecked] = useState(false);
    const [isOnlineChecked, setIsOnlineChecked] = useState(false);

    const [showPaymentOptions, setShowPaymentOptions] = useState(false);
    const [showPaymentData, setShowPaymentData] = useState(false);

    const [appliedCoupon, setAppliedCoupon] = useState(null);
    const [gstData, setGstData] = useState(null);
    const [showPopup, setShowPopup] = useState(false);

    const [isScheduled, setIsScheduled] = useState(false);
    const [isOrdered, setIsOrdered] = useState(false);
    const [orderId, setOrderId] = useState(null);

    const [inputValue, setInputValue] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);

    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const userId = Number(localStorage.getItem("userId"));
    const vendorId = Number(localStorage.getItem("vendorId") || 42);
    const token = localStorage.getItem("authToken");

    const paymentSectionRef = useRef(null);
    const placeOrderRef = useRef(null);
    const [userProfile, setUserProfile] = useState(null);

    const [userCompany, setUserCompany] = useState(null);
    const [isCompanyUser, setIsCompanyUser] = useState(false);
    const [availablePostPaid, setAvailablePostPaid] = useState(0);

    const [orderType, setOrderType] = useState(null);

    const [showAddressPopup, setShowAddressPopup] = useState(false);
    const [addresses, setAddresses] = useState([]);
    const [address, setAddress] = useState("");
    const [selectedAddressObj, setSelectedAddressObj] = useState(null);

    const [selectedAddress, setSelectedAddress] = useState(null);
    const [isLocating, setIsLocating] = useState(false);

    const [map, setMap] = useState(null);
    const [marker, setMarker] = useState(null);
    const [latLng, setLatLng] = useState(null);
    const mapRef = useRef(null);
    const markerRef = useRef(null);
    const searchInputRef = useRef(null);

    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);

    const autocompleteRef = useRef(null);

    const [couponId, setCouponId] = useState(null);
    const [isAddressConfirmed, setIsAddressConfirmed] = useState(false);

    const [showAddAddressForm, setShowAddAddressForm] = useState(false);
    const [google, setGoogle] = useState(null);

    const [googleMapsLoaded, setGoogleMapsLoaded] = useState(false);
    const [mapInitialized, setMapInitialized] = useState(false);

    const [savedSchedule, setSavedSchedule] = useState(null);





    const [addressForm, setAddressForm] = useState({
        doorNumber: "",
        addressLine: "",
        landMark: "",
        city: "",
        state: "",
        pincode: "",
        name: "",
        phoneNumber: "",
        latitude: "",
        longitude: ""
    });

    const isGoogleReady = () => window.google && window.google.maps && window.google.maps.places;

    const suggestions = ['kphb Manjeera Trinity 3rd gate straight line'];
    const walletTypesMap = {
        self: "SELF_LOADED",
        company: "COMPANY_LOADED",
        cashback: "CASHBACK",
        postpaid: "POST_PAID",
    };

    const extractAddressFields = (components = []) => {
        const get = (type) => components.find(c => c.types.includes(type))?.long_name || "";
        return {
            city: get("locality") || get("administrative_area_level_2"),
            state: get("administrative_area_level_1"),
            pincode: get("postal_code"),
        };
    };

    const searchLocation = () => {
        const query = searchInputRef.current?.value;
        if (!query) {
            alert("Please enter a location");
            return;
        }

        if (!window.google || !window.google.maps) {
            alert("Google Maps is still loading. Please try again in a moment.");
            return;
        }

        const geocoder = new window.google.maps.Geocoder();

        geocoder.geocode({ address: query }, (results, status) => {
            if (status === "OK" && results[0]) {
                const result = results[0];
                const location = result.geometry.location;
                const lat = location.lat();
                const lng = location.lng();

                moveMap(lat, lng);

                const { city, state, pincode } = extractAddressFields(result.address_components);

                setAddressForm(prev => ({
                    ...prev,
                    city,
                    state,
                    pincode,
                    latitude: lat,
                    longitude: lng
                }));
            } else {
                alert("Location not found. Please try another search.");
            }
        });
    };

    const getMinTime = () => {
        if (!selectedDate) return "00:00";
        const today = new Date().toISOString().split("T")[0];
        const now = new Date();
        if (selectedDate !== today) return "00:00";
        const twoHoursLater = new Date(now.getTime() + 2 * 60 * 60 * 1000);
        const hours = twoHoursLater.getHours();
        const minutes = twoHoursLater.getMinutes();
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    };

    const handleSearchEnter = (e) => {
        if (e.key !== "Enter") return;

        e.preventDefault();

        const inputValue = searchInputRef.current?.value;
        if (!inputValue) return;

        const geocoder = new google.maps.Geocoder();

        geocoder.geocode({ address: inputValue }, (results, status) => {
            if (status === "OK" && results[0]) {
                const location = results[0].geometry.location;
                const lat = location.lat();
                const lng = location.lng();

                setLatitude(lat);
                setLongitude(lng);

                // ✅ SAFE CHECK
                if (mapRef.current) {
                    mapRef.current.setCenter({ lat, lng });
                    mapRef.current.setZoom(16);
                } else {
                    console.warn("Map is not initialized yet");
                }

                // ✅ SAFE CHECK
                if (markerRef.current) {
                    markerRef.current.setPosition({ lat, lng });
                    markerRef.current.setVisible(true);
                } else {
                    console.warn("Marker is not initialized yet");
                }

            } else {
                alert("Location not found. Please try another search.");
            }
        });
    };

    const moveMap = (lat, lng) => {
        setLatitude(lat);
        setLongitude(lng);
        setAddressForm(prev => ({
            ...prev,
            latitude: lat,
            longitude: lng
        }));

        if (mapRef.current && mapRef.current.setCenter) {
            mapRef.current.setCenter({ lat, lng });
            mapRef.current.setZoom(16);
        } else {
            console.warn("Map not ready, will retry...");
            // Retry after a short delay
            setTimeout(() => {
                if (mapRef.current && mapRef.current.setCenter) {
                    mapRef.current.setCenter({ lat, lng });
                    mapRef.current.setZoom(16);
                }
            }, 500);
        }

        if (markerRef.current && markerRef.current.setPosition) {
            markerRef.current.setPosition({ lat, lng });
            markerRef.current.setVisible(true);
        }
    };

   
    const GOOGLE_MAPS_API_KEY = "AIzaSyDRcDLmtI8sk6pFB3w1o1N0RyPnRYO2HXQ";

    const loadGoogleMapsScript = () => {
        return new Promise((resolve, reject) => {
            if (window.google && window.google.maps && window.google.maps.places) {
                resolve(window.google);
                return;
            }

            // Remove existing script if any
            const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
            if (existingScript) {
                existingScript.remove();
            }

            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places,geometry`;
            script.async = true;
            script.defer = true;
            script.onload = () => resolve(window.google);
            script.onerror = (error) => {
                console.error("Google Maps script failed to load", error);
                reject(error);
            };
            document.head.appendChild(script);
        });
    };
    useEffect(() => {
        if (window.google && window.google.maps) {
            setGoogleMapsLoaded(true);
            return;
        }

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDRcDLmtI8sk6pFB3w1o1N0RyPnRYO2HXQ&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = () => {
            setGoogleMapsLoaded(true);
        };
        script.onerror = () => {
            console.error("Failed to load Google Maps");
        };
        document.head.appendChild(script);

        return () => {
            // Cleanup if needed
        };
    }, []);



    useEffect(() => {
        let isMounted = true;

        const initGoogleMaps = async () => {
            try {
                await loadGoogleMapsScript();
                if (isMounted) {
                    setGoogleMapsLoaded(true);
                    console.log("✅ Google Maps loaded successfully");
                }
            } catch (error) {
                console.error("❌ Failed to load Google Maps:", error);
                if (isMounted) {
                    alert("Failed to load maps. Please check your internet connection and refresh the page.");
                }
            }
        };

        initGoogleMaps();

        return () => {
            isMounted = false;
        };
    }, []);

    // Fixed map initialization useEffect
    useEffect(() => {
        if (!showAddressPopup || !googleMapsLoaded) {
            return;
        }

        let isMounted = true;
        let retryCount = 0;
        const maxRetries = 10;

        const initializeMap = () => {
            // Check if Google Maps is fully loaded
            if (!window.google || !window.google.maps || !window.google.maps.places) {
                if (retryCount < maxRetries) {
                    retryCount++;
                    console.log(`Waiting for Google Maps... retry ${retryCount}/${maxRetries}`);
                    setTimeout(initializeMap, 500);
                } else {
                    console.error("Google Maps failed to load after multiple retries");
                    alert("Maps failed to load. Please refresh the page.");
                }
                return;
            }

            const mapElement = document.getElementById("map");
            if (!mapElement) {
                console.error("Map element not found");
                return;
            }

            if (!isMounted) return;

            try {
                // Default center (India)
                const defaultCenter = { lat: 20.5937, lng: 78.9629 };

                // Initialize map
                mapRef.current = new window.google.maps.Map(mapElement, {
                    center: defaultCenter,
                    zoom: 5,
                    mapTypeControl: false,
                    fullscreenControl: true,
                    streetViewControl: false,
                    zoomControl: true,
                });

                // Initialize marker
                markerRef.current = new window.google.maps.Marker({
                    map: mapRef.current,
                    draggable: true,
                    visible: false,
                    animation: window.google.maps.Animation.DROP,
                });

                // Setup autocomplete for search input
                if (searchInputRef.current) {
                    const autocomplete = new window.google.maps.places.Autocomplete(searchInputRef.current, {
                        types: ["geocode"],
                        componentRestrictions: { country: "IN" }
                    });

                    autocomplete.addListener("place_changed", () => {
                        const place = autocomplete.getPlace();
                        if (place && place.geometry && place.geometry.location) {
                            const lat = place.geometry.location.lat();
                            const lng = place.geometry.location.lng();
                            moveMap(lat, lng);

                            // Extract address components
                            if (place.address_components) {
                                const { city, state, pincode } = extractAddressFields(place.address_components);
                                setAddressForm(prev => ({
                                    ...prev,
                                    city,
                                    state,
                                    pincode,
                                    latitude: lat,
                                    longitude: lng
                                }));
                            }
                        }
                    });
                }

                // Add dragend listener to marker
                markerRef.current.addListener("dragend", (e) => {
                    if (isMounted) {
                        const lat = e.latLng.lat();
                        const lng = e.latLng.lng();
                        setLatitude(lat);
                        setLongitude(lng);
                        setAddressForm(prev => ({
                            ...prev,
                            latitude: lat,
                            longitude: lng
                        }));

                        // Reverse geocode to get address
                        const geocoder = new window.google.maps.Geocoder();
                        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                            if (status === "OK" && results[0]) {
                                const { city, state, pincode } = extractAddressFields(results[0].address_components);
                                setAddressForm(prev => ({
                                    ...prev,
                                    city,
                                    state,
                                    pincode
                                }));
                            }
                        });
                    }
                });

                setMapInitialized(true);
                console.log("✅ Map initialized successfully");

            } catch (error) {
                console.error("Error initializing map:", error);
            }
        };

        // Small delay to ensure DOM is ready
        setTimeout(initializeMap, 100);

        return () => {
            isMounted = false;
            setMapInitialized(false);
            // Clean up markers and map
            if (markerRef.current) {
                markerRef.current.setMap(null);
                markerRef.current = null;
            }
            if (mapRef.current) {
                mapRef.current = null;
            }
        };
    }, [showAddressPopup, googleMapsLoaded]);
    const submitNewAddress = async () => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");

        if (!addressForm.latitude || !addressForm.longitude) {
            alert("Please select location on map or use current location");
            return;
        }

        const addressParts = [
            addressForm.doorNumber,
            addressForm.addressLine,
            addressForm.landMark,
            addressForm.city,
            addressForm.state
        ].filter(Boolean);

        const addressString = addressParts.join(", ");

        const payload = {
            id: 0,
            userId: Number(userId),
            doorNumber: addressForm.doorNumber,
            addressLine: addressForm.addressLine,
            landMark: addressForm.landMark,
            city: addressForm.city,
            state: addressForm.state,
            pincode: Number(addressForm.pincode),
            name: addressForm.name,
            phoneNumber: addressForm.phoneNumber,
            latitude: Number(addressForm.latitude),
            longitude: Number(addressForm.longitude),
            address: addressString
        };

        try {
            await axios.post("https://backend.maamaas.com/subscription/api/user/location/add", payload, {
                headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
            });
            alert("Address saved successfully");
            fetchAddresses();
            setShowAddAddressForm(false);
        } catch (error) {
            console.error("Failed to add address", error);
            alert("Failed to save address");
        }
    };

    useEffect(() => {
        if (showAddressPopup) {
            const last = localStorage.getItem("lastDeliveryAddress");
            if (last) {
                const parsed = JSON.parse(last);
                setSelectedAddressObj(parsed);
                setAddress(parsed.addressLine || "");
            }
        }
    }, [showAddressPopup]);

    useEffect(() => {
        if (showAddressPopup && window.google) {
            loadMap();
        }
    }, [showAddressPopup]);

    const loadMap = () => {
        const mapElement = document.getElementById("map");
        if (!mapElement) {
            console.error("Map element not found");
            return;
        }

        if (!window.google || !window.google.maps) {
            console.error("Google Maps not loaded");
            return;
        }

        const map = new window.google.maps.Map(mapElement, {
            center: { lat: 28.6139, lng: 77.2090 },
            zoom: 14,
        });

        markerRef.current = new window.google.maps.Marker({
            map,
            draggable: true,
            position: { lat: 28.6139, lng: 77.2090 },
        });
    };

    const safeMapOperation = (operation, fallback = null) => {
        if (mapRef.current && mapRef.current.setCenter) {
            return operation();
        } else {
            console.warn("Map not available for operation");
            return fallback;
        }
    };

    // Usage example:
    safeMapOperation(() => {
        mapRef.current.setCenter({ lat: 28.6139, lng: 77.2090 });
        mapRef.current.setZoom(16);
    });

    const detectCurrentLocation = () => {
        if (!navigator.geolocation) {
            alert("Geolocation is not supported by your browser");
            return;
        }

        setIsLocating(true);

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;

                console.log("📍 Current location:", lat, lng);

                setLatitude(lat);
                setLongitude(lng);

                // Move map to current location
                if (mapRef.current && mapRef.current.setCenter) {
                    mapRef.current.setCenter({ lat, lng });
                    mapRef.current.setZoom(16);
                }

                if (markerRef.current && markerRef.current.setPosition) {
                    markerRef.current.setPosition({ lat, lng });
                    markerRef.current.setVisible(true);
                }

                // Reverse geocode to get address
                if (window.google && window.google.maps) {
                    const geocoder = new window.google.maps.Geocoder();
                    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                        if (status === "OK" && results[0]) {
                            const address = results[0].formatted_address;
                            const { city, state, pincode } = extractAddressFields(results[0].address_components);

                            setAddressForm(prev => ({
                                ...prev,
                                city,
                                state,
                                pincode,
                                latitude: lat,
                                longitude: lng
                            }));

                            // Update search input
                            if (searchInputRef.current) {
                                searchInputRef.current.value = address;
                            }

                            console.log("📍 Address found:", address);
                        } else {
                            setAddressForm(prev => ({
                                ...prev,
                                latitude: lat,
                                longitude: lng
                            }));
                        }
                        setIsLocating(false);
                    });
                } else {
                    setIsLocating(false);
                }
            },
            (error) => {
                console.error("Geolocation error:", error);
                let errorMessage = "Unable to fetch your location. ";
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        errorMessage += "Please allow location access.";
                        break;
                    case error.POSITION_UNAVAILABLE:
                        errorMessage += "Location information is unavailable.";
                        break;
                    case error.TIMEOUT:
                        errorMessage += "Location request timed out.";
                        break;
                    default:
                        errorMessage += "Please try again.";
                }
                alert(errorMessage);
                setIsLocating(false);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );
    };
    const handleSavedAddressClick = (addr) => {
        setSelectedAddressObj(addr);
        setAddress(addr.address || addr.addressLine || "");

        // ✅ Check if map is initialized before using
        if (addr.latitude != null && addr.longitude != null) {
            const lat = Number(addr.latitude);
            const lng = Number(addr.longitude);

            // Wait for map to be ready
            const trySetLocation = () => {
                if (mapRef.current && markerRef.current) {
                    if (markerRef.current.setPosition) {
                        markerRef.current.setPosition({ lat, lng });
                        markerRef.current.setVisible(true);
                    }
                    if (mapRef.current.setCenter) {
                        mapRef.current.setCenter({ lat, lng });
                        mapRef.current.setZoom(16);
                    }
                } else {
                    // Retry after a short delay
                    setTimeout(trySetLocation, 100);
                }
            };

            trySetLocation();
        }

        confirmAddress(addr);
    };
    const confirmAddress = async () => {
        try {
            const token = localStorage.getItem("authToken");
            const cartId = localStorage.getItem("cartId");
            const addressId = selectedAddressObj?.id;

            if (!cartId) {
                alert("Cart not found. Please add items to cart.");
                return;
            }
            if (!addressId) {
                alert("Please select a saved address");
                return;
            }

            const res = await axios.put(
                `https://backend.maamaas.com/food/api/cart/delivery/${cartId}/address/${addressId}`,
                null,
                { headers: { Authorization: `Bearer ${token}`, Accept: "*/*" } }
            );

            fetchCartDetails();
            setShowAddressPopup(false);
        } catch (error) {
            const errorMsg = error.response?.data?.message || error.response?.data || error.message;
            console.error("Failed to assign address:", errorMsg);
        }
    };

    useEffect(() => {
        setIsOrdered(false);
        setShowPaymentOptions(false);
        if (orderType !== "DELIVERY") {
            setSelectedAddress(null);
        }
    }, [orderType]);

    const fetchAddresses = async () => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");
        if (!userId) return;
        try {
            const res = await axios.get(`https://backend.maamaas.com/subscription/api/user/get/addresses/${userId}`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
            });
            setAddresses(res.data || []);
        } catch (err) {
            console.error("Fetch address error", err);
        }
    };

    useEffect(() => {
        fetchAddresses();
    }, []);

    // Fetch cart data - FIXED VERSION
    const fetchCartDetails = async () => {
        try {
            if (!userId) return;
            const res = await axios.get(`https://backend.maamaas.com/food/api/cart/get/user/without-seating?userId=${userId}`, {
                headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
            });
            const data = Array.isArray(res.data) ? res.data[0] || {} : res.data;
            if (data.cartId) localStorage.setItem("cartId", data.cartId);
            if (data.orderType) setOrderType(data.orderType);
            const cartItems = Array.isArray(data.cartItems) ? data.cartItems : [];
            setCartItems(cartItems);
            const categories = ["Allcarts", ...new Set(cartItems.map((item) => item.dishName))];
            setAllCategories(categories);
            setDisplayData(cartItems);
            setFilteredItems(cartItems.length === 0 ? [] : cartItems);
            if (data.userCompany && data.userCompany !== "") setIsCompanyUser(true);
            else setIsCompanyUser(false);
            const initialQuantities = {};
            cartItems.forEach((item) => { initialQuantities[item.itemId] = item.quantity || 1; });
            setQuantities(initialQuantities);
            setSubTotal(data.subtotal || 0);
            setTotal(data.total || 0);
            setGstTotal(data.gstTotal || 0);
            setPlatformCharges(data.platformCharges || 0);
            setServiceCharges(data.serviceCharges || 0);
            setPackingCharges(data.packingTotal || 0);
            setDeliveryCharges(data.deliveryCharges || 0);
            setCouponId(data.couponId ?? null);
            setDiscountAmount(data.discountAmount || 0);
            setAppliedCoupon(data.discountAmount > 0);
            setGrandTotal(data.grandTotal || 0);
        } catch (err) {
            console.error("Error fetching cart details:", err.message);
        }
    };

    const fetchWalletData = async () => {
        try {
            const response = await axios.get(`https://backend.maamaas.com/subscription/api/user/wallet/${userId}`, {
                headers: { Authorization: `Bearer ${token}`, Accept: "*/*", "Content-Type": "application/json" },
            });
            const data = response.data;
            setAvailableBalance(data.totalBalance || 0);
            setAvailableCompany(data.companyLoadedAmount || 0);
            setAvailableSelf(data.selfLoadedAmount || 0);
            setAvailableCashback(data.cashbackAmount || 0);
        } catch (error) {
            console.error("Balance API Error:", error);
        }
    };

    useEffect(() => {
        const fetchUserProfile = async () => {
            try {
                const userId = localStorage.getItem("userId");
                const token = localStorage.getItem("authToken");
                if (!userId || !token) return;
                const response = await axios.get(`https://backend.maamaas.com/subscription/api/user/getprofile/${userId}`, {
                    headers: { accept: "*/*", Authorization: `Bearer ${token}` },
                });
                setUserProfile(response.data);
            } catch (error) {
                console.error("Failed to fetch user profile", error);
            }
        };
        fetchUserProfile();
    }, []);

    // Handle quantity increment - FIXED VERSION
    const incrementQuantity = async (item) => {
        if (!item?.itemId) return;

        const currentQty = quantities[item.itemId] || 0;
        const newQuantity = currentQty + 1;

        try {
            // ✅ FIXED: Use correct endpoint with query parameters
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/cart/update/item?userId=${userId}&quantity=${newQuantity}&itemId=${item.itemId}`,
                null,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                        Accept: "*/*"
                    },
                }
            );

            if (response.status === 200) {
                setQuantities(prev => ({
                    ...prev,
                    [item.itemId]: newQuantity
                }));
                fetchCartDetails();
            }
        } catch (err) {
            console.error("❌ Error updating item quantity:", err.message);
            if (err.response) {
                console.log("Server error:", err.response.data);
                alert(err.response.data?.message || "Unable to update cart. Please try again.");
            } else {
                alert("Unable to update cart right now. Please try again.");
            }
        }
    };

    // Handle quantity decrement - FIXED VERSION
    const decrementQuantity = async (item) => {
        if (!item?.itemId) return;

        const currentQty = quantities[item.itemId] || 0;
        if (currentQty <= 0) return;

        const newQuantity = currentQty - 1;

        try {
            // ✅ FIXED: Use correct endpoint with query parameters
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/cart/update/item?userId=${userId}&quantity=${newQuantity}&itemId=${item.itemId}`,
                null,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                        Accept: "*/*"
                    },
                }
            );

            if (response.status === 200) {
                if (newQuantity === 0) {
                    setQuantities(prev => {
                        const updated = { ...prev };
                        delete updated[item.itemId];
                        return updated;
                    });
                } else {
                    setQuantities(prev => ({
                        ...prev,
                        [item.itemId]: newQuantity
                    }));
                }
                fetchCartDetails();
            }
        } catch (err) {
            console.error("❌ Error updating item quantity:", err.message);
            if (err.response) {
                console.log("Server error:", err.response.data);
                alert(err.response.data?.message || "Unable to update cart. Please try again.");
            } else {
                alert("Unable to update cart right now. Please try again.");
            }
        }
    };

    const handleClearCart = async () => {
        if (!userId) {
            alert("User ID not found!");
            return;
        }

        try {
            // ✅ CORRECTED: Use the exact endpoint from your API
            const response = await axios.delete(
                `https://backend.maamaas.com/food/api/cart/delete/user/cart?userId=${userId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    },
                }
            );

            if (response.status === 200) {
                alert("Cart cleared successfully!");
                setCartItems([]);
                setDisplayData([]);
                setQuantities({});
                // Also clear localStorage cartId
                localStorage.removeItem("cartId");
                // Refresh cart details
                fetchCartDetails();
            } else {
                alert("Failed to clear the cart.");
            }
        } catch (error) {
            console.error("❌ Error clearing cart:", error);
            if (error.response) {
                console.log("Server error:", error.response.data);
                alert(error.response.data?.message || "An error occurred while clearing the cart.");
            } else {
                alert("An error occurred while clearing the cart.");
            }
        }
    };

    const handleShowGST = async () => {
        try {
            const response = await axios.get(`https://backend.maamaas.com/food/api/cart/get/user/without-seating?userId=${userId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const data = response.data;
            const gstArray = Array.isArray(data) ? data.map((item) => ({
                serviceChargeGst: item.serviceChargeGst ?? 0,
                platformChargeGst: item.platformChargeGst ?? 0,
                cgst: item.cgst ?? 0,
                sgst: item.sgst ?? 0,
            })) : [{
                serviceChargeGst: data.serviceChargeGst ?? 0,
                platformChargeGst: data.platformChargeGst ?? 0,
                cgst: data.cgst ?? 0,
                sgst: data.sgst ?? 0,
            }];
            setGstData(gstArray);
            setShowPopup(true);
        } catch (err) {
            console.error("Error fetching GST data:", err);
        }
    };

    const toggleServiceCharges = async () => {
        const cartId = localStorage.getItem("cartId");
        if (!cartId) { alert("Cart ID is missing"); return; }
        const newStatus = serviceApplied ? "NOT_APPLICABLE" : "APPLICABLE";
        try {
            setLoading(true);
            await axios.put(`https://backend.maamaas.com/food/api/cart/coupon/${cartId}`, {
                id: 0,
                serviceCharge: newStatus,
            }, { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } });
            setServiceApplied(!serviceApplied);
            fetchCartDetails();
        } catch (error) {
            console.error("Failed to update service charge:", error.message);
            alert("Failed to update service charge. Try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleCheckboxChange = (e, method) => {
        const isChecked = e.target.checked;

        // If checking a new method, uncheck others
        if (isChecked) {
            setIsWalletChecked(method === "wallet");
            setIsOnlineChecked(method === "online");
            setIsCashChecked(method === "cash");
            setSelectedPaymentMethod(
                method === "wallet" ? "Maamaas_Wallet" :
                    method === "online" ? "Online_Payment" : "Cash"
            );
            if (method === "wallet") {
                setShowWalletOptions(true);
            } else {
                setShowWalletOptions(false);
                setSelectedwalletTypes("");
            }
        } else {
            // Uncheck only the current method
            if (method === "wallet") {
                setIsWalletChecked(false);
                setShowWalletOptions(false);
                setSelectedwalletTypes("");
                setSelectedPaymentMethod("");
            } else if (method === "online") {
                setIsOnlineChecked(false);
                setSelectedPaymentMethod("");
            } else if (method === "cash") {
                setIsCashChecked(false);
                setSelectedPaymentMethod("");
            }
        }
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        if (value.trim() === '') {
            setShowDropdown(false);
            setFilteredSuggestions([]);
            return;
        }
        const filtered = suggestions.filter((item) => item.toLowerCase().includes(value.toLowerCase()));
        setFilteredSuggestions(filtered);
        setShowDropdown(filtered.length > 0);
    };

    const handleSelect = (value) => {
        setInputValue(value);
        setShowDropdown(false);
        const encodedLocation = encodeURIComponent(value);
        const mapsUrl = `https://maps.app.goo.gl/JvgyXhfkMA3pp7LX6?q=${encodedLocation}`;
        setIsSecondModalOpen(true);
    };

    const handleUseMyLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const { latitude, longitude } = position.coords;
                const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
                window.open(mapsUrl, '_blank');
            }, (error) => { alert("Location access denied. Please enable location services."); });
        } else { alert("Geolocation is not supported by this browser."); }
    };

    const handleSaveDetails = () => {
        const details = { orderType: selectedOrderType, date: selectedDate, time: selectedTime || "" };
        setSavedDetails(details);
        closeThirdModal();
    };

    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            if (window.Razorpay) {
                resolve(true);
                return;
            }
            const script = document.createElement('script');
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    const handleRemoveCoupon = async () => {
        try {
            const cartId = localStorage.getItem("cartId");
            const token = localStorage.getItem("authToken");
            const storedCoupon = JSON.parse(localStorage.getItem("appliedCoupon"));
            const finalCouponId = couponId || storedCoupon?.id;
            if (!cartId || !finalCouponId) { alert("No applied coupon found!"); return; }
            const body = { id: Number(finalCouponId), applyCoupon: "NOT_APPLIED" };
            const response = await axios.put(`https://backend.maamaas.com/food/api/cart/coupon/${cartId}`, body, {
                headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
            });
            console.log("Coupon removed:", response.data);
            localStorage.removeItem("appliedCoupon");
            setAppliedCoupon(false);
            setDiscountAmount(0);
            setCouponId(null);
            fetchCartDetails();
        } catch (error) {
            console.error("Failed to remove coupon:", error.response?.data || error.message);
            alert("Failed to remove coupon. Please try again.");
        }
    };

    // ================= MAIN PAYMENT HANDLERS =================

    const handleOnlinePayment = async (userId, token, cartId) => {
        try {
            const amount = grandTotal;
            const amountInPaise = grandTotal; // no *100

            const isLoaded = await loadRazorpayScript();
            if (!isLoaded) {
                alert("Razorpay SDK failed to load");
                return;
            }

            const orderRes = await axios.post(
                "https://backend.maamaas.com/food/api/payments/create-order/user",
                { amount: amountInPaise, currency: "INR", receipt: `order_${Date.now()}` },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const razorpayOrderId = orderRes.data?.id || orderRes.data?.orderId;

            const options = {
                key: "rzp_live_RU5whSMu9rPV7s",
                amount: amountInPaise,
                currency: "INR",
                order_id: razorpayOrderId,
                handler: async function (response) {
                    try {
                        const paymentId = response.razorpay_payment_id;
                        const rzpOrderId = response.razorpay_order_id;

                        await axios.post(
                            "https://backend.maamaas.com/food/api/payments/capture",
                            { paymentId, orderId: rzpOrderId, amount: amountInPaise },
                            { headers: { Authorization: `Bearer ${token}` } }
                        );

                        const orderResponse = await axios.post(
                            `https://backend.maamaas.com/food/api/orders/orders/create/${cartId}`,
                            null,
                            {
                                params: {
                                    userId,
                                    paymentMethod: "Online_Payment",
                                    amount,
                                    razorpayPaymentId: paymentId,
                                    razorpayOrderId: rzpOrderId
                                },
                                headers: { Authorization: `Bearer ${token}` }
                            }
                        );

                        const newOrderId = orderResponse.data?.orderId;

                        if (newOrderId) {
                            localStorage.setItem("orderId", newOrderId);
                            setOrderId(newOrderId);
                            setShowPaymentData(true);
                        }

                        alert("Order placed successfully!");
                        localStorage.removeItem("cartId");

                    } catch (err) {
                        console.error("Post payment error:", err);
                        alert("Payment success but order failed");
                    }
                }
            };

            const rzp = new window.Razorpay(options);
            rzp.open();

        } catch (err) {
            console.error("Payment Error:", err);
            alert("Payment failed");
        }
    };

    // Wallet Payment - FIXED VERSION
    const handleWalletPayment = async (userId, token, cartId) => {
        const mappedwalletTypes = walletTypesMap[selectedwalletTypes];

        if (!mappedwalletTypes) {
            alert("Please select a wallet type");
            return;
        }

        try {
            let response;

            // =========================
            // ✅ SCHEDULE ORDER
            // =========================
            if (selectedDate && selectedTime) {
                const [hour, minute] = selectedTime.split(":");

                const schedulePayload = {
                    date: selectedDate,
                    time: {
                        hour: Number(hour),
                        minute: Number(minute),
                        second: 0,
                        nano: 0,
                    },
                    schedule: true,
                    paymentMethod: "Maamaas_Wallet",
                    razorpayPaymentId: "N/A",
                    razorpayOrderId: "N/A",
                    walletTypes: [mappedwalletTypes], // ✅ keep array
                    totalAmount: grandTotal,
                };

                response = await axios.post(
                    `https://backend.maamaas.com/food/api/orders/shedule/order/${cartId}`,
                    schedulePayload,
                    {
                        params: { userId },
                        headers: {
                            Authorization: `Bearer ${token}`, // ✅ REQUIRED
                            "Content-Type": "application/json",
                        },
                    }
                );

                alert("✅ Schedule Order placed successfully!");
            }

            // =========================
            // ✅ NORMAL ORDER
            // =========================
            else {
                response = await axios.post(
                    `https://backend.maamaas.com/food/api/orders/orders/create/${cartId}`,
                    {}, // ✅ NOT null
                    {
                        params: {
                            userId,
                            paymentMethod: "Maamaas_Wallet",
                            walletTypes: mappedwalletTypes, // ✅ string
                            amount: grandTotal, // ✅ confirm with backend
                            razorpayPaymentId: "N/A",
                            razorpayOrderId: "N/A",
                        },
                        headers: {
                            Authorization: `Bearer ${token}`, // ✅ REQUIRED
                        },
                    }
                );

                alert("✅ Order placed successfully using wallet!");
            }

            // =========================
            // ✅ COMMON RESPONSE
            // =========================
            const newOrderId = response.data?.orderId;

            if (newOrderId) {
                localStorage.setItem("orderId", newOrderId);
                setOrderId(newOrderId);
                setShowPaymentData(true);
            }

        } catch (error) {
            console.error("❌ Wallet Payment Error:", error);

            console.log("ERROR RESPONSE:", error.response);

            alert(
                error.response?.data?.message ||
                error.response?.data?.error ||
                "Wallet payment failed"
            );
        }
    };
    const handleCashPayment = async (userId, token, cartId) => {
        try {
            const response = await axios.post(
                `https://backend.maamaas.com/food/api/orders/orders/create/${cartId}`,
                null,
                {
                    params: { userId, paymentMethod: "Cash" },
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            const newOrderId = response.data?.orderId;

            if (newOrderId) {
                localStorage.setItem("orderId", newOrderId);
                setOrderId(newOrderId);
                setShowPaymentData(true);
            }

            alert("Order placed successfully! Pay on delivery.");
            localStorage.removeItem("cartId");

        } catch (error) {
            console.error("Cash Payment Error:", error);
            alert("Cash order failed");
        }
    };

    const handlePlaceOrder = async () => {
        // ✅ Validation checks
        if (!selectedPaymentMethod) {
            alert("Please select a payment method");
            return;
        }

        // ✅ Special validation for wallet payment
        if (selectedPaymentMethod === "Maamaas_Wallet") {
            if (!selectedwalletTypes) {
                alert("Please select a wallet type (Self Loaded, Company Loaded, or Cashback)");
                return;
            }
        }

        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");
        const cartId = localStorage.getItem("cartId");

        if (!userId || !token) {
            alert("User not logged in. Please login again.");
            return;
        }

        if (!cartId) {
            alert("Cart is empty. Please add items to cart.");
            return;
        }

        setLoading(true);

        try {
            if (selectedPaymentMethod === "Online_Payment") {
                await handleOnlinePayment(userId, token, cartId);
            } else if (selectedPaymentMethod === "Maamaas_Wallet") {
                await handleWalletPayment(userId, token, cartId);
            } else if (selectedPaymentMethod === "Cash") {
                await handleCashPayment(userId, token, cartId);
            }
        } catch (error) {
            console.error("❌ Place Order Error:", error);
            alert(error.response?.data?.message || "Failed to place order. Please try again.");
        } finally {
            setLoading(false);
        }
    };


    const closeModal = () => setIsModalOpen(false);
    const openSecondModal = () => setIsSecondModalOpen(true);
    const closeSecondModal = () => setIsSecondModalOpen(false);
    const openThirdModal = () => setIsThirdModalOpen(true);
    const closeThirdModal = () => setIsThirdModalOpen(false);

    useEffect(() => {
        fetchCartDetails();
        fetchWalletData();
    }, [userId, refresh]);

    useEffect(() => {
        if (appliedCoupon) {
            localStorage.setItem("appliedCoupon", JSON.stringify(appliedCoupon));
        }
    }, [appliedCoupon]);

    useEffect(() => {
        const handleResize = () => { setIsMobile(window.innerWidth <= 768); };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [isMobile, setIsMobile] = useState(false);

    if (showPaymentData) {
        return selectedDate && selectedTime ? <Sheduleorder /> : <Paymentdata />;
    }

    return (
        <div className="ordercart-container">
            {/* Rest of your JSX remains the same */}
            <div className="cart-content">
                {/* Review Cart Section */}
                <div className="review-cart-section">
                    <div className="section-headery" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", marginBottom: "10px", flexWrap: "nowrap" }}>
                        <h2 style={{ margin: 0, fontSize: window.innerWidth < 768 ? "16px" : "20px", fontWeight: "600", color: "#ee6521" }}>Review your Cart</h2>
                        <button className="clear-cart-btn" onClick={handleClearCart} style={{ padding: window.innerWidth < 768 ? "6px 10px" : "8px 14px", fontSize: window.innerWidth < 768 ? "12px" : "14px", borderRadius: "6px", cursor: "pointer", whiteSpace: "nowrap" }}>Clear Cart</button>
                    </div>

                    {displayData.length > 0 ? (
                        <div className="cart-table-container">
                            <div className="cart-table">
                                <div className="table-header">
                                    <div>S.NO</div><div>ITEM</div><div>QUANTITY</div><div>PRICE</div><div>TOTAL</div><div>NOTE</div>
                                </div>
                                {displayData.map((item, index) => (
                                    <div className="table-row" key={item.itemId}>
                                        <div>{index + 1}</div>
                                        <div className="item-name">{item.dishName}</div>
                                        <div>
                                            <div className="quantity-control">
                                                <button onClick={() => decrementQuantity({ ...item, itemId: item.itemId })} className="quantity-btn">-</button>
                                                <span className="quantity-value">{quantities[item.itemId] || 0}</span>
                                                <button onClick={() => incrementQuantity({ ...item, itemId: item.itemId })} className="quantity-btn">+</button>
                                            </div>
                                        </div>
                                        <div>₹{item.price?.toFixed(2)}</div>
                                        <div>₹{item.totalPrice?.toFixed(2)}</div>
                                        <div><input type="text" placeholder="Add note..." className="note-input" /></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="empty-cart">
                            <p>Your cart is empty</p>
                            <Link to={`/Newmenuiteam/${vendorId}`} className="add-items-btn">Add Items</Link>

                        </div>
                    )}
                </div>

                {/* Price Summary Section */}
                <div className="price-summary-section">
                    <h3>Price Summary</h3>
                    <div className="price-row"><span>Sub Total</span><span>₹{subTotal.toFixed(2)}</span></div>
                    <div className="price-row"><span>Platform Charges</span><span>₹{platformCharges.toFixed(2)}</span></div>
                    {orderType === "DINE_IN" && (<div className="price-row"></div>)}
                    {packingCharges > 0 && (<div className="price-row"><span>Packing Charges</span><span>₹{packingCharges.toFixed(2)}</span></div>)}
                    {deliveryCharges > 0 && (<div className="price-row"><span>Delivery Charges</span><span>₹{deliveryCharges.toFixed(2)}</span></div>)}
                    <div className="price-row"><span>GST<FaInfoCircle className="info-icon" onClick={() => handleShowGST(userId)} /></span><span>₹{gstTotal.toFixed(2)}</span></div>
                    <div className="divider"></div>
                    <div className="price-row total"><span>Total</span><span>₹{total.toFixed(2)}</span></div>
                    <div className="price-row">
                        {!appliedCoupon || discountAmount <= 0 ? (
                            <button className="apply-discount-btn" onClick={() => navigate("/profilepage", { state: { activeCategory: "Notifications" } })}>Apply Discount</button>
                        ) : (
                            <div className="discount-row"><button className="remove-discount-btn" onClick={handleRemoveCoupon}>Remove</button><span className="discount-price">-₹{discountAmount.toFixed(2)}</span></div>
                        )}
                    </div>
                    <div className="divider"></div>
                    <div className="price-row grand-total"><span>Grand Total</span><span>₹{grandTotal.toFixed(2)}</span></div>
                </div>

                {/* Add More Items Section */}
                <div className="add-more-section">
                    <Link to={`/Newmenuiteam/${vendorId}`} className="add-more-link"><span className="missed-text">Missed Something?</span><span className="add-text">Add More Items</span></Link>
                </div>

                {/* Order Type Selection */}
                <div className="order-type-buttons">

                    {/* Order Now */}
                    <button
                        className="order-type-btn active"
                        disabled={isScheduled}
                        onClick={() => {
                            setIsOrdered(true);
                            setShowPaymentOptions(true);
                            setTimeout(() => {
                                paymentSectionRef.current?.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start"
                                });
                            }, 200);
                        }}
                    >
                        Order Now
                    </button>

                    {/* Schedule */}
                    <button
                        className={`order-type-btn ${isScheduled ? "active" : ""}`}
                        disabled={isOrdered}
                        onClick={() => {
                            openThirdModal();
                            setIsScheduled(true);
                        }}
                    >
                        Schedule Order
                    </button>

                    {/* 👇 Schedule Box inline */}
                    {savedSchedule && (
                        <div className="schedule-box-inline">
                            <span>{savedSchedule.date}</span>
                            <span>{savedSchedule.time}</span>
                        </div>
                    )}

                </div>

                {/* Address Popup */}
                {showAddressPopup && (
                    <div className="popup-overlay">
                        <div className="popup-box">
                            <span className="close-btn" onClick={() => setShowAddressPopup(false)}>✖</span>
                            <h3>Select Delivery Address</h3>
                            <div style={{ position: "relative", width: "100%", maxWidth: "400px" }}>
                                <span onClick={searchLocation} style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", fontSize: "16px", color: "#666", cursor: "pointer", userSelect: "none" }}>🔍</span>
                                <input type="text" ref={searchInputRef} placeholder="Search location (area, street, landmark)" onKeyDown={handleSearchEnter} style={{ width: "100%", padding: "10px 40px 10px 12px", fontSize: "14px", border: "1px solid #ccc", borderRadius: "6px", outline: "none" }} />
                            </div>
                            <div id="map" className="map-box"></div>
                            <button className="location-btn" onClick={detectCurrentLocation} disabled={isLocating}>{isLocating ? <span className="spinner"></span> : "📍 Use My Current Location"}</button>
                            <div className="saved-list">
                                <div style={{ display: "flex", justifyContent: "center", marginBottom: "3px" }}>
                                    <button type="button" onClick={() => setShowAddAddressForm(true)} style={{ padding: "8px 14px", backgroundColor: "#ee6521", color: "#fff", border: "none", borderRadius: "6px", fontSize: "14px", fontWeight: "500", cursor: "pointer" }}>Add Address</button>
                                </div>
                                {showAddAddressForm && (
                                    <div className="add-address-form">
                                        <input type="text" placeholder="Door Number" value={addressForm.doorNumber} onChange={(e) => setAddressForm({ ...addressForm, doorNumber: e.target.value })} />
                                        <input type="text" placeholder="Address Line" value={addressForm.addressLine} onChange={(e) => setAddressForm({ ...addressForm, addressLine: e.target.value })} />
                                        <input type="text" placeholder="Landmark" value={addressForm.landMark} onChange={(e) => setAddressForm({ ...addressForm, landMark: e.target.value })} />
                                        <input type="text" placeholder="City" value={addressForm.city} onChange={(e) => setAddressForm({ ...addressForm, city: e.target.value })} />
                                        <input type="text" placeholder="State" value={addressForm.state} onChange={(e) => setAddressForm({ ...addressForm, state: e.target.value })} />
                                        <input type="number" placeholder="Pincode" value={addressForm.pincode} onChange={(e) => setAddressForm({ ...addressForm, pincode: e.target.value })} />
                                        <input type="text" placeholder="Name" value={addressForm.name} onChange={(e) => setAddressForm({ ...addressForm, name: e.target.value })} />
                                        <input type="text" placeholder="Phone Number" value={addressForm.phoneNumber} onChange={(e) => setAddressForm({ ...addressForm, phoneNumber: e.target.value })} />
                                        <button className="confirm-btn" onClick={submitNewAddress}>Save Address</button>
                                    </div>
                                )}
                                {addresses.map((a, i) => (
                                    <div key={i} className={`saved-card ${selectedAddressObj?.id === a.id ? "active" : ""}`} onClick={() => handleSavedAddressClick(a)}>
                                        <b>{a.category}</b><p>{a.address}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {/* Schedule Order Modal */}
                <Modal isOpen={isThirdModalOpen} onRequestClose={closeThirdModal} contentLabel="Schedule Order" className="modal-overlay" overlayClassName="modal-backdrop">
                    <div className="modal-content">
                        <div className="modal-header"><h3>SCHEDULE ORDER</h3><button onClick={closeThirdModal} className="modal-close-btn">✕</button></div>
                        <div className="modal-body">
                            <div className="datetime-inputs">
                                <input type="date" value={selectedDate} min={new Date().toISOString().split("T")[0]} onChange={(e) => { setSelectedDate(e.target.value); setSelectedTime(""); }} className="date-input" />
                                <input type="time" value={selectedTime} min={getMinTime()} step={1800} onChange={(e) => setSelectedTime(e.target.value)} className="time-input" />
                            </div>
                            <div className="modal-actions center-btn">
                                <button
                                    className="save-btn"
                                    onClick={() => {
                                        handleSaveDetails();

                                        // 👇 yaha save karo
                                        setSavedSchedule({
                                            date: selectedDate,
                                            time: selectedTime
                                        });

                                        setShowPaymentOptions(true);

                                        setTimeout(() => {
                                            paymentSectionRef.current?.scrollIntoView({
                                                behavior: "smooth",
                                                block: "start"
                                            });
                                        }, 200);
                                    }}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>



                {/* Payment Options */}
                {showPaymentOptions && (
                    <div className="payment-options-section" ref={paymentSectionRef} style={{ width: "100%", padding: "10px", position: "relative" }}>
                        <div className="payment-methods" style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "flex-start" }}>
                            <div className="payment-method-card" style={{ flex: "1 1 200px", border: "1px solid #ccc", borderRadius: "6px", padding: "6px 10px", display: "flex", flexDirection: "column", gap: "6px", position: "relative" }}>
                                <div className="method-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "10px" }}>
                                    <div className="method-checkbox" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                        <input type="checkbox" checked={isWalletChecked} onChange={(e) => handleCheckboxChange(e, "wallet")} id="wallet-payment" style={{ width: "16px", height: "16px" }} />
                                        <label htmlFor="wallet-payment" style={{ fontSize: "14px", cursor: "pointer" }}>
                                            Wallet
                                            {selectedwalletTypes && isWalletChecked && (
                                                <span style={{ color: "#ffeb3b", fontWeight: "bold", marginLeft: "5px" }}>
                                                    ({selectedwalletTypes === "company" ? "Company Loaded" :
                                                        selectedwalletTypes === "self" ? "Self Loaded" :
                                                            selectedwalletTypes === "cashback" ? "Cashback" : "Post Paid"})
                                                </span>
                                            )}
                                        </label>
                                    </div>
                                    <button
                                        className="wallet-balance-btn"
                                        style={{ padding: "4px 10px", fontSize: "13px", height: "28px", cursor: "pointer" }}
                                        onClick={() => setShowWalletOptions(!showWalletOptions)}
                                    >
                                        ₹{Number(availableBalance).toFixed(2)}
                                    </button>
                                </div>
                                {showWalletOptions && (
                                    <div className="wallet-options" style={{ position: "absolute", top: "40px", left: "0", width: "100%", background: "#ee6521", border: "1px solid #ccc", borderRadius: "4px", padding: "6px 0", zIndex: 10, display: "flex", flexDirection: "column", cursor: "pointer", gap: "4px", boxShadow: "0 2px 5px rgba(0,0,0,0.15)" }}>
                                        <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "13px", padding: "2px 10px", cursor: "pointer" }}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                                                <input
                                                    type="radio"
                                                    name="walletTypes"
                                                    value="company"
                                                    checked={selectedwalletTypes === "company"}
                                                    onChange={() => {
                                                        setSelectedwalletTypes("company");
                                                        setShowWalletOptions(false);
                                                    }}
                                                />
                                                <span>Company Loaded</span>
                                            </div>
                                            <span>₹{Number(availableCompany).toFixed(2)}</span>
                                        </label>
                                        <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "13px", padding: "2px 10px", cursor: "pointer" }}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <input
                                                    type="radio"
                                                    name="walletTypes"
                                                    value="self"
                                                    checked={selectedwalletTypes === "self"}
                                                    onChange={() => {
                                                        setSelectedwalletTypes("self");
                                                        setShowWalletOptions(false);
                                                    }}
                                                />
                                                <span>Self Loaded</span>
                                            </div>
                                            <span>₹{Number(availableSelf).toFixed(2)}</span>
                                        </label>
                                        <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "13px", padding: "2px 10px", cursor: "pointer" }}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <input
                                                    type="radio"
                                                    name="walletTypes"
                                                    value="cashback"
                                                    checked={selectedwalletTypes === "cashback"}
                                                    onChange={() => {
                                                        setSelectedwalletTypes("cashback");
                                                        setShowWalletOptions(false);
                                                    }}
                                                />
                                                <span>Cashback</span>
                                            </div>
                                            <span>₹{Number(availableCashback).toFixed(2)}</span>
                                        </label>
                                        {isCompanyUser && (
                                            <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "13px", padding: "2px 10px", cursor: "pointer" }}>
                                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                    <input
                                                        type="radio"
                                                        name="walletTypes"
                                                        value="postpaid"
                                                        checked={selectedwalletTypes === "postpaid"}
                                                        onChange={() => {
                                                            setSelectedwalletTypes("postpaid");
                                                            setShowWalletOptions(false);
                                                        }}
                                                    />
                                                    <span>Post Paid</span>
                                                </div>
                                            </label>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="payment-method-card" style={{ flex: "1 1 200px", border: "1px solid #ccc", borderRadius: "6px", padding: "6px 10px", display: "flex", alignItems: "center", gap: "6px", minHeight: "57px", position: "relative" }}>
                                <input type="checkbox" checked={isOnlineChecked} onChange={(e) => handleCheckboxChange(e, "online")} id="online-payment" style={{ width: "16px", height: "20px" }} />
                                <label htmlFor="online-payment" style={{ fontSize: "14px", cursor: "pointer" }}>Online Payment</label>
                            </div>
                        </div>
                        <div className="place-order-section">
                            <button className="place-order-btn" onClick={handlePlaceOrder} disabled={loading} style={{ opacity: loading ? 0.6 : 1, cursor: loading ? "not-allowed" : "pointer" }}>{loading ? "Processing..." : "Place Order"}</button>
                        </div>
                    </div>
                )}

                {/* GST Popup */}
                {showPopup && (
                    <div className="gst-popup-overlay">
                        <div className="gst-popup">
                            <h3>GST Breakdown</h3>
                            {gstData && gstData.length > 0 ? gstData.map((gst, index) => (
                                <div className="gst-details" key={index}>
                                    <div className="gst-row"><span>Service Charge GST:</span><span>₹{gst.serviceChargeGst}</span></div>
                                    <div className="gst-row"><span>Platform Charge GST:</span><span>₹{gst.platformChargeGst}</span></div>
                                    <div className="gst-row"><span>CGST:</span><span>₹{gst.cgst}</span></div>
                                    <div className="gst-row"><span>SGST:</span><span>₹{gst.sgst}</span></div>
                                </div>
                            )) : <p className="no-gst-data">No GST data available</p>}
                            <button className="close-popup-btn" onClick={() => setShowPopup(false)}>Close</button>
                        </div>
                    </div>
                )}
            </div>

            <style jsx>{`
                .ordercart-container { padding: 15px; max-width: 1200px; margin: 0 auto; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif; }
                .cart-content { display: flex; flex-direction: column; gap: 24px; }
                .review-cart-section { background: white; border-radius: 12px; padding: 16px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); }
                .section-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; padding-bottom: 16px; border-bottom: 2px solid #f0f0f0; }
                .section-header h2 { font-size: 24px; font-weight: 600; color: #333; margin: 0; }
                .clear-cart-btn { background: #fff; border: 2px solid #dc3545; color: #dc3545; padding: 8px 16px; border-radius: 6px; font-weight: 600; cursor: pointer; transition: all 0.3s ease; }
                .clear-cart-btn:hover { background: #dc3545; color: #fff; }
                .cart-table-container { overflow-x: auto; }
                .cart-table { display: grid; grid-template-columns: 60px 1fr 150px 100px 100px 150px; width: 100%; min-width: 800px; }
                .table-header { display: contents; font-weight: 600; color: #666; font-size: 14px; text-transform: uppercase; letter-spacing: 0.5px; }
                .table-header > div { padding: 12px; background: #ee6521; border-bottom: 2px solid #e9ecef; color: white; display: flex; align-items: center; }
                .table-row { display: contents; }
                .table-row > div { padding: 16px 12px; color: white; display: flex; align-items: center; border-bottom: 1px solid #f0f0f0;color: #159318; font-weight: bold;font-size: 15px; }
                .item-name { font-weight: 500; color: white; }
                .quantity-control { display: flex; align-items: center; background: #f8f9fa; border-radius: 8px; padding: 4px; width: fit-content; }
                .quantity-btn { width: 32px; height: 32px; border: none; background: #fff; border-radius: 6px; font-size: 18px; font-weight: 600; cursor: pointer; display: flex; align-items: center; justify-content: center; color: #333; transition: all 0.2s ease; }
                .quantity-btn:hover { background: #e9ecef; color: #333; }
                .quantity-value { min-width: 40px; text-align: center; font-weight: 600; color: #333; }
                .note-input { width: 100%; padding: 8px 12px; border: 1px solid #ddd; border-radius: 6px; font-size: 14px; transition: border-color 0.2s ease; }
                .note-input:focus { outline: none; border-color: #ee6521; box-shadow: 0 0 0 2px rgba(177, 92, 214, 0.1); }
                .empty-cart { text-align: center; padding: 60px 20px; color: white; }
                .empty-cart p { font-size: 18px; margin-bottom: 20px; }
                .add-items-btn { display: inline-block; background: #ee6521; color: white; padding: 12px 32px; border-radius: 8px; text-decoration: none; font-weight: 600; transition: background-color 0.3s ease; }
                .add-items-btn:hover { background: #9e49c4; }
                .price-summary-section { background: #ee6521; border-radius: 12px; padding: 24px; color: white; }
                .price-summary-section h3 { font-size: 20px; font-weight: 600; text-align: center; }
                .price-row { display: flex; justify-content: space-between; align-items: center; padding: 5px 0; font-size: 16px; }
                .price-row.total { font-weight: 600; font-size: 18px; }
                .price-row.grand-total { font-weight: 700; font-size: 20px; }
                .popup-overlay { position: fixed; inset: 0; background: rgba(0, 0, 0, 0.6); display: flex; align-items: center; justify-content: center; z-index: 9999; }
                .popup-box { background: #fff; width: 95%; height: 600px; overflow: auto; max-width: 460px; border-radius: 14px; padding: 16px; position: relative; box-shadow: 0 8px 30px rgba(0,0,0,0.25); scrollbar-width: none; }
                .close-btn { position: absolute; top: 12px; right: 14px; font-size: 18px; cursor: pointer; }
                .popup-box h3 { margin-bottom: 10px; font-size: 18px; font-weight: 600; }
                .map-box { width: 100%; height: 220px; border-radius: 10px; margin-bottom: 12px; overflow: hidden; }
                .location-btn { width: 100%; padding: 11px; border-radius: 10px; border: none; background: #eef4ff; color: #0057ff; font-weight: 500; cursor: pointer; margin-bottom: 10px; }
                .popup-box input { width: 100%; padding: 11px; border-radius: 10px; border: 1px solid #dcdcdc; outline: none; font-size: 14px; margin-bottom: 10px; }
                .popup-box input:focus { border-color: #0057ff; }
                .confirm-btn { width: 100%; padding: 12px; background: #28a745; color: white; font-size: 15px; border-radius: 10px; border: none; cursor: pointer; margin-bottom: 14px; }
                .saved-list { max-height: 260px; overflow-y: auto; padding-right: 6px; }
                .saved-list::-webkit-scrollbar { width: 0px; background: transparent; }
                .saved-list { scrollbar-width: none; }
                .saved-card { padding: 10px; border-radius: 10px; border: 1px solid #e5e5e5; margin-bottom: 8px; cursor: pointer; transition: 0.2s; text-align: left; }
                .saved-card:hover { background: #f7faff; }
                .saved-card.active { border-color: #0057ff; background: #eef4ff; }
                .saved-card b { font-size: 14px; }
                .saved-card p { font-size: 13px; margin-top: 4px; color: #555; }
                .spinner { width: 18px; height: 18px; border: 3px solid #ddd; border-top: 3px solid #2196f3; border-radius: 50%; animation: spin 0.8s linear infinite; display: inline-block; }
                @keyframes spin { to { transform: rotate(360deg); } }
                .location-btn:disabled { opacity: 0.6; cursor: not-allowed; }
                .discount-row { display: flex; justify-content: space-between; align-items: center; width: 100%; }
                .discount-price { font-weight: 600; color: WHITE; white-space: nowrap; }
                @media (max-width: 480px) { .discount-row { gap: 10px; } .remove-discount-btn { font-size: 13px; padding: 6px 10px; } .discount-price { font-size: 14px; } }
                .modal-actions.center-btn { display: flex; justify-content: center; margin-top: 20px; }
                .service-charge-toggle { cursor: pointer; padding: 4px 8px; background: rgba(255, 255, 255, 0.2); border-radius: 4px; transition: background-color 0.2s ease; }
                .service-charge-toggle:hover { background: rgba(255, 255, 255, 0.3); }
                .info-icon { margin-left: 8px; cursor: pointer; color: #00bb5a; vertical-align: middle; }
                .divider { height: 1px; background: rgba(255, 255, 255, 0.3); margin: 16px 0; }
                .discount-section { display: flex; align-items: center; gap: 12px; padding: 12px 0; }
                .apply-discount-btn, .remove-discount-btn { padding: 8px 16px; border: 1px solid rgba(255, 255, 255, 0.5); background: rgba(255, 255, 255, 0.1); color: white; border-radius: 6px; cursor: pointer; font-weight: 500; transition: all 0.2s ease; }
                .apply-discount-btn:hover, .remove-discount-btn:hover { background: rgba(255, 255, 255, 0.2); }
                .discount-amount { font-weight: 600; color: #ff6b6b; }
                .add-more-section { background: #ee6521; border-radius: 12px; padding: 20px; text-align: center; }
                .add-more-link { text-decoration: none; display: block; }
                .missed-text { color: #333; font-weight: 600; margin-right: 8px; }
                .add-text { color: white; font-weight: 600; }
                .order-type-section { text-align: center; }
                .order-type-buttons { display: flex; gap: 20px; justify-content: center; flex-wrap: wrap; }
                .order-type-btn { padding: 12px 32px; border-radius: 8px; font-weight: 600; font-size: 16px; cursor: pointer; transition: all 0.3s ease; border: 2px solid #ee6521; background: #ee6521; color: white; }
                .order-type-btn:disabled { background: transparent; color: #888; cursor: not-allowed; }
                .order-type-btn.active { background: #ee6521; color: white; }
                .payment-options-section { background: #fff; border-radius: 12px; padding: 24px; margin-top: -20px; }
                .payment-methods { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 20px; margin-bottom: 24px; }
                .payment-method-card { background: #ee6521; border-radius: 12px; padding: 7px; color: white; }
                .method-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; }
                .method-checkbox { display: flex; align-items: center; gap: 12px; }
                .method-checkbox input[type="checkbox"] { width: 20px; height: 20px; cursor: pointer; }
                .method-label { font-size: 18px; font-weight: 600; cursor: pointer; }
                .wallet-balance-btn { background: white; color: #ee6521; border: none; padding: 8px 16px; border-radius: 8px; font-weight: 600; cursor: pointer; }
                .wallet-options { display: flex; flex-direction: column; gap: 12px; margin-top: 16px; }
                .wallet-option { display: flex; justify-content: space-between; align-items: center; padding: 12px; background: rgba(255, 255, 255, 0.1); border-radius: 8px; cursor: pointer; }
                .wallet-option input[type="radio"] { margin-right: 12px; }
                .wallet-amount { font-weight: 600; background: white; color: #ee6521; padding: 4px 12px; border-radius: 6px; font-size: 14px; }
                .place-order-section { text-align: center; }
                .place-order-btn { background: #ee6521; color: white; border: none; padding: 16px 48px; font-size: 18px; font-weight: 600; border-radius: 10px; cursor: pointer; transition: background-color 0.3s ease; box-shadow: 0 4px 12px rgba(177, 92, 214, 0.3); }
                .place-order-btn:hover { background: #9e49c4; }
                .gst-popup-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
                .gst-popup { background: white; padding: 24px; border-radius: 12px; max-width: 400px; width: 90%; max-height: 80vh; overflow-y: auto; }
                .gst-popup h3 { margin-bottom: 16px; color: #333; text-align: center; }
                .gst-details { background: #f8f9fa; padding: 16px; border-radius: 8px; margin-bottom: 16px; }
                .gst-row { display: flex; justify-content: space-between; padding: 8px 0; border-bottom: 1px solid #e9ecef; }
                .gst-row:last-child { border-bottom: none; }
                .no-gst-data { text-align: center; color: #666; padding: 20px; }
                .close-popup-btn { width: 100%; padding: 12px; background: #ee6521; color: white; border: none; border-radius: 8px; font-weight: 600; cursor: pointer; margin-top: 16px; }
                .modal-backdrop { background: rgba(0, 0, 0, 0.5); position: fixed; top: 0; left: 15; right: 0; bottom: 0; z-index: 1000; }
                .modal-overlay { position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; border-radius: 12px; max-width: 400px; height: 400px; width: 90%; outline: none; z-index: 1001; }
                .modal-content { border-radius: 12px; overflow: hidden; }
                .modal-header { background: #ee6521; color: white; padding: 20px; display: flex; justify-content: space-between; align-items: center; }
                .modal-header h3 { margin: 0; font-size: 18px; font-weight: 600; }
                .modal-close-btn { background: transparent; border: none; color: white; font-size: 24px; cursor: pointer; padding: 0; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; }
                .modal-body { padding: 24px; }
                .datetime-inputs { display: flex; gap: 16px; margin-bottom: 24px; color: black; }
                .date-input, .time-input { flex: 1; padding: 12px; border: 1px solid #ddd; color: black; border-radius: 8px; font-size: 16px; }
                .modal-actions { text-align: center; }
                .save-btn { background: #ee6521; color: white; border: none; padding: 12px 32px; border-radius: 8px; font-weight: 600; cursor: pointer; font-size: 16px; }
                @media (max-width: 768px) {
                    .ordercart-container { padding: 16px; width: 100vw; }
                    .review-cart-section, .price-summary-section, .add-more-section, .payment-options-section { padding: 16px; }
                    .section-header { flex-direction: column; align-items: flex-start; gap: 12px; }
                    .section-header h2 { font-size: 20px; }
                    .clear-cart-btn { align-self: flex-end; }
                    .cart-table { grid-template-columns: 40px 1fr 120px 80px 80px 120px; font-size: 14px; min-width: 600px; }
                    .table-header > div, .table-row > div { padding: 8px; }
                    .payment-methods { grid-template-columns: 1fr; }
                    .order-type-buttons { display: flex; gap: 20px; justify-content: center; flex-wrap: wrap; }
                    .order-type-btn { width: 100%; }
                    .datetime-inputs { flex-direction: column; gap: 12px; }
                }
                @media (max-width: 480px) {
                    .cart-table { grid-template-columns: 30px 1fr 100px 70px 70px 100px; font-size: 12px; min-width: 400px; }
                    .quantity-btn { width: 28px; height: 28px; font-size: 16px; }
                    .quantity-value { min-width: 30px; }
                    .note-input { padding: 6px; font-size: 12px; }
                    .price-row { font-size: 14px; padding: 8px 0; }
                    .method-label { font-size: 16px; }
                    .wallet-balance-btn { padding: 6px 12px; font-size: 14px; }
                    .search-input-wrapper { position: relative; width: 100%; margin-bottom: 10px; }
                    .search-location-input { width: 100%; padding: 10px 12px 10px 36px; border-radius: 6px; border: 1px solid #ccc; }
                    .search-icon { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); font-size: 16px; color: #777; }
                }
            `}</style>
        </div>
    );
};

export default Ordercart;

